/* DreamCloud → the daily chart under the tiles.
 *
 * Hand-written SVG on purpose: no chart library (the console bundles what it
 * uses and a library is a lot of bundle for three lines). The scaling is
 * chartPaths in js/rules/dreamcloud.js, tested; this draws what it returns.
 *
 * The SVG has a viewBox and no fixed height, so it scales with its width and
 * keeps its shape on a phone instead of being squashed flat.
 */
import * as Vue from 'vue';
import { chartDays, chartPaths, seriesMax } from '../rules/dreamcloud.js';

var W = 700;
var H = 160;

var SERIES = [
  { key: 'paid_clicks_google', label: 'Paid clicks', cls: 'is-clicks' },
  { key: 'online_bookings', label: 'Online bookings', cls: 'is-bookings' },
  { key: 'online_bookings_no_click', label: 'Bookings with no click', cls: 'is-noclick' }
];
var KEYS = SERIES.map(function (s) { return s.key; });

function shortDay(ymd) {
  var d = new Date(String(ymd) + 'T12:00:00');
  if (isNaN(d.getTime())) return String(ymd || '');
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export const DcChart = {
  name: 'DcChart',
  props: { days: { type: Array, default: function () { return []; } } },
  setup: function (props) {
    var rows = Vue.computed(function () { return chartDays(props.days); });
    var paths = Vue.computed(function () { return chartPaths(rows.value, KEYS, W, H); });
    var max = Vue.computed(function () { return seriesMax(rows.value, KEYS); });
    var first = Vue.computed(function () { return rows.value.length ? shortDay(rows.value[0].day) : ''; });
    var last = Vue.computed(function () {
      return rows.value.length ? shortDay(rows.value[rows.value.length - 1].day) : '';
    });
    var label = Vue.computed(function () {
      return 'Daily paid clicks, online bookings and bookings with no click, ' +
        first.value + ' to ' + last.value + '. Highest value ' + max.value + '.';
    });
    return {
      series: SERIES, rows: rows, paths: paths, max: max, first: first, last: last,
      label: label, viewBox: '-4 -6 ' + (W + 8) + ' ' + (H + 12), W: W, H: H
    };
  },
  template: [
    '<div class="dc-card dc-chart">',
    '  <ul class="dc-legend">',
    '    <li v-for="s in series" :key="s.key" :class="s.cls"><span class="dc-legend__key"></span>{{ s.label }}</li>',
    '  </ul>',
    '  <p v-if="rows.length < 2" class="dc-muted dc-chart__none">The chart needs two days or more;',
    '    today&rsquo;s figures are in the tiles above.</p>',
    '  <template v-else>',
    '    <div class="dc-chart__plot">',
    '      <span class="dc-chart__max" aria-hidden="true">{{ max }}</span>',
    '      <svg :viewBox="viewBox" class="dc-chart__svg" role="img" :aria-label="label">',
    '        <line class="dc-chart__axis" x1="0" :y1="H" :x2="W" :y2="H" />',
    '        <line class="dc-chart__grid" x1="0" y1="0" :x2="W" y2="0" />',
    '        <polyline v-for="s in series" :key="s.key" class="dc-chart__line" :class="s.cls"',
    '          :points="paths[s.key]" vector-effect="non-scaling-stroke" />',
    '      </svg>',
    '    </div>',
    '    <div class="dc-chart__days" aria-hidden="true"><span>{{ first }}</span><span>{{ last }}</span></div>',
    '  </template>',
    '</div>'
  ].join('\n')
};
